export default __webpack_public_path__ + "static/media/sean-github.0fefecdb.jpg";